import type { LayoutNode } from "../layout/types.js";
import type { CompiledNode, CompileNodeContext } from "./types.js";
import { compileBarLoaderNode } from "./compileBarLoader.js";
import { compileContainerNode } from "./compileContainerNode.js";
import { compileCustomDisciplineButtonNode } from "./compileCustomDisciplineButtonNode.js";
import { compileCustomDisciplineInputNode } from "./compileCustomDisciplineInputNode.js";
import { compileImageNode } from "./compileImageNode.js";
import { compileIconNode } from "./compileIconNode.js";
import { compileLayoutListNode } from "./compileLayoutListNode.js";
import { compileQrCodeNode } from "./compileQrCodeNode.js";
import { compileShapeNode } from "./compileShapeNode.js";
import { compileTextNode } from "./compileTextNode.js";
import { compileVideoNode } from "./compileVideoNode.js";

export function compileNode(
  node: LayoutNode,
  compileContext: CompileNodeContext,
): CompiledNode | null {
  if (node.kind === "container") {
    return compileContainerNode(node, compileContext);
  }

  if (node.kind === "primitive" && node.primitive === "text") {
    return compileTextNode(node, compileContext);
  }

  if (node.kind === "primitive" && node.primitive === "shape") {
    return compileShapeNode(node, compileContext);
  }

  if (node.kind === "primitive" && node.primitive === "image") {
    return compileImageNode(node, compileContext);
  }

  if (node.kind === "primitive" && node.primitive === "video") {
    return compileVideoNode(node, compileContext);
  }

  if (node.kind === "component" && node.component === "layoutList") {
    return compileLayoutListNode(node, compileContext);
  }

  if (node.kind === "component" && node.component === "barLoader") {
    return compileBarLoaderNode(node, compileContext);
  }

  if (node.kind === "component" && node.component === "qrCode") {
    return compileQrCodeNode(node, compileContext);
  }

  if (node.kind === "component" && node.component === "icon") {
    return compileIconNode(node, compileContext);
  }

  if (
    node.kind === "component" &&
    node.component === "customDisciplineButton"
  ) {
    return compileCustomDisciplineButtonNode(node, compileContext);
  }

  if (node.kind === "component" && node.component === "customDisciplineInput") {
    return compileCustomDisciplineInputNode(node, compileContext);
  }

  return null;
}
